export default __webpack_public_path__ + "static/media/ql_07.bd017b3a.png";